import * as types from '@/constants/mutationTypes'

const state = {
  search: {
    keywordGmail: '',
    keywordTemplates: ''
  }
}
const getters = {
  search: state => state.search
}
const actions = {
  setSearch ({commit}, data) {
    commit(types.SET_SEARCH, {data})
  }
}
const mutations = {
  [types.SET_SEARCH] (state, {data}) {
    state.search = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/Search/modules/store.js